import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';

import { Provider } from 'react-redux';
import store from './reducers/index.js';

import $ from 'jquery';
window.$ = $;
window.jQuery = $;
window.Popper = require('popper.js').default;
require('bootstrap');
require('font-awesome/css/font-awesome.min.css');

ReactDOM.render(
  <Provider store={ store() }>
    <App />
  </Provider>,
  document.getElementById('root')
);




// WEBPACK FOOTER //
// ./src/index.js